module.exports = __webpack_public_path__ + "media/images/sgs_iso_27701-a7e9316a04c779bd03a3ac1fd1d024aa.svg";